"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = PriceLockup;
exports.oldTagStyles = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _core = require("@linaria/core");
var _text = _interopRequireDefault(require("@ux/text"));
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _index = _interopRequireDefault(require("../tooltip/index.js"));
var _index2 = _interopRequireDefault(require("../tag/index.js"));
var _oldPrice = _interopRequireDefault(require("./old-price"));
var _index3 = _interopRequireDefault(require("../klarna-merchandising/index.js"));
/* eslint-disable complexity */

const priceContainer = "core-pfq7g4c";
const PriceTagWrapper = "core-p1o4l2n5";
const oldTagStyles = exports.oldTagStyles = "core-o1gpbe75";
const PriceWrapper = "core-prrm0up";
const PriceDetailContainer = "core-p1s8wzn1";
const detailStyles = "core-dqkxpit";
const ConditionsWrapper = "core-c4ilwyo";
const ConditionsTooltipWrapper = "core-c1vdnh2b";
const KlarnaWrapper = "core-k74sr47";
const StrikeThroughPrice = "core-sigs3tg";
const extractIntlNum = valueString => {
  // Check if the number uses comma for decimal separator by checking if it has a dot followed by a comma
  const usesCommaForDecimal = valueString?.match(/\..*,/);
  const radixChar = usesCommaForDecimal ? ',' : '.';
  const invalidCharRegex = new RegExp(`[^0-9${radixChar}]`, 'g');
  return Number(valueString?.replace(invalidCharRegex, '')?.replace(radixChar, '.'));
};

/**
 * PriceLockup Component.
 * @module PriceLockup
 *
 * @param {Object} props React props
 * @param {Number} props.priceLockupVersion Version of the price layout (1 = legacy, 2 = modern)
 * @param {String} props.priceTag Tag label text
 * @param {String} props.oldPrice Previous price text
 * @param {Node} props.price Main price value
 * @param {String} props.priceDetail Price detail (e.g., '/mo')
 * @param {Boolean} props.strikeThroughPriceEnd Render strike-through price at the end
 * @param {Object} props.klarnaLockup Klarna configuration
 * @param {String} props.align Text alignment
 * @param {Array} props.items List of items shown below the price disclaimer
 * @returns {React.ReactElement} PriceLockup component
 * @public
 */
function PriceLockup({
  priceLockupVersion,
  ...props
}) {
  const {
    align = 'start',
    items,
    price,
    priceTag,
    priceTagDesign = 'warning',
    oldPrice,
    priceDetail,
    klarnaLockup,
    strikeThroughPriceEnd = false
  } = props;
  if (priceLockupVersion === 1) {
    return /*#__PURE__*/_react.default.createElement(_oldPrice.default, props);
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    "data-cy": "price-lockup",
    className: (0, _core.cx)(`align-${align}`, priceContainer, 'price-lockup')
  }, (priceTag || oldPrice) && /*#__PURE__*/_react.default.createElement("div", {
    className: PriceTagWrapper
  }, priceTag && /*#__PURE__*/_react.default.createElement(_index2.default, {
    dataCy: "price-tag",
    text: priceTag,
    design: priceTagDesign
  }), oldPrice && !strikeThroughPriceEnd && /*#__PURE__*/_react.default.createElement(_text.default.p, {
    "data-cy": "strikethru-price",
    className: (0, _core.cx)('text-uppercase', oldTagStyles),
    size: -1
  }, oldPrice)), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _core.cx)('price-wrapper', PriceWrapper),
    "data-cy": "price"
  }, price && /*#__PURE__*/_react.default.createElement(_text.default.h3, {
    as: "heading",
    size: 2,
    "data-cy": "price-heading",
    className: "price-heading"
  }, price), priceDetail && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _core.cx)('price-detail', PriceDetailContainer)
  }, /*#__PURE__*/_react.default.createElement(_text.default.p, {
    as: "title",
    size: -1,
    "data-cy": "detail",
    className: detailStyles
  }, priceDetail)), oldPrice && strikeThroughPriceEnd && /*#__PURE__*/_react.default.createElement("div", {
    className: StrikeThroughPrice
  }, /*#__PURE__*/_react.default.createElement(_text.default.h3, {
    as: "heading",
    size: 2,
    "data-cy": "strike-through-detail-price",
    className: "strike-through-detail-price"
  }, oldPrice), priceDetail && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _core.cx)('price-detail', PriceDetailContainer)
  }, /*#__PURE__*/_react.default.createElement(_text.default.p, {
    as: "paragraph",
    size: -1,
    "data-cy": "detail",
    className: detailStyles
  }, priceDetail)))), items && /*#__PURE__*/_react.default.createElement("div", {
    "data-cy": "conditions"
  }, items.map(({
    text: itemText,
    tooltip
  }, i) => {
    if (tooltip) {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: ConditionsWrapper,
        key: i
      }, /*#__PURE__*/_react.default.createElement(_text.default.p, {
        as: "paragraph",
        size: -2,
        "data-cy": "pricing-condition"
      }, itemText), tooltip && /*#__PURE__*/_react.default.createElement("div", {
        className: ConditionsTooltipWrapper,
        "data-cy": "tooltip-wrapper"
      }, /*#__PURE__*/_react.default.createElement(_index.default, tooltip)));
    }
    return /*#__PURE__*/_react.default.createElement(_text.default.p, {
      as: "paragraph",
      size: -2,
      "data-cy": "renewal-text-item",
      key: i
    }, itemText);
  })), klarnaLockup && klarnaLockup.price && /*#__PURE__*/_react.default.createElement("div", {
    className: KlarnaWrapper
  }, /*#__PURE__*/_react.default.createElement(_text.default.span, {
    as: "paragraph",
    size: -1
  }, /*#__PURE__*/_react.default.createElement(_index3.default, (0, _extends2.default)({}, klarnaLockup, {
    price: Number((extractIntlNum(klarnaLockup.price) * 1000000).toFixed())
  })))));
}
PriceLockup.propTypes = {
  priceLockupVersion: _propTypes.default.number,
  priceTag: _propTypes.default.string,
  priceTagDesign: _propTypes.default.oneOf(['warning', 'passive']),
  oldPrice: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),
  price: _propTypes.default.node,
  priceDetail: _propTypes.default.string,
  items: _propTypes.default.arrayOf(_propTypes.default.shape({
    text: _propTypes.default.node,
    tooltip: _propTypes.default.object
  })),
  align: _propTypes.default.oneOf(['start', 'center', 'end']),
  klarnaLockup: _propTypes.default.shape({
    eids: _propTypes.default.object,
    price: _propTypes.default.string,
    channel: _propTypes.default.string,
    logoUrl: _propTypes.default.string,
    onError: _propTypes.default.func,
    hideLogo: _propTypes.default.bool,
    isSmallText: _propTypes.default.bool,
    placementKey: _propTypes.default.string,
    paymentConfigUrl: _propTypes.default.string
  }),
  strikeThroughPriceEnd: _propTypes.default.bool
};